import request from "../utils/request";
// 图/文搜图
export function searchImages(params){
  return request({
    url: `/searchImage/searchImages`,
    method: "post",
    data:params,
    timeout: 0
  });
}
// 获取所有的记录列表
export function searchLogList(params){
  const queryString = Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');
  return request({
    url: `/searchImage/logList?${queryString}`,
    method: "get"
  });
}

// 查单条
export function searchLogById(params){
  const queryString = Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');
  return request({
    url: `/searchImage/getById?${queryString}`,
    method: "get"
  });
}


// 获取所有用户
export function allUser(){
  return request({
    url: `/platform/getAllUserName?userName=`,
    method: "get"
  });
}